import { render, staticRenderFns } from "./top-index.vue?vue&type=template&id=6b5302ee&scoped=true&"
import script from "./top-index.vue?vue&type=script&lang=js&"
export * from "./top-index.vue?vue&type=script&lang=js&"
import style0 from "./top-index.vue?vue&type=style&index=0&id=6b5302ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5302ee",
  null
  
)

export default component.exports